/*
* Thème: PERFORMANCE
*/

/*
* Side Arrows
*/

$('.card-custom__content').each(function () {
  if ($(this).text().trim() === '') {
    $(this).hide();
  }
});

function updateSwiperHeight(swiper) {
  let grid = swiper.el.querySelector('.grid');
  if (!grid) return;
  let swiperHeight = grid.clientHeight;
  let wrapper = swiper.$el[0].closest('.infinite-slider-layout')
  let picture = grid.querySelector('picture');
  let imageHeight = picture ? picture.clientHeight : 0;
  if (wrapper) {
    wrapper.style.setProperty('--swiper-height', `${swiperHeight}px`);
    if (imageHeight) {
      wrapper.style.setProperty('--image-height', `${imageHeight}px`);
    }
  }

}

window.Carousel_SideArrows = function() {
  return {
    on: {
      // Sans boucle quand tout tient à l'écran, sinon Swiper duplique des cartes pour remplir
      beforeInit: function (swiper) {
        let breakpoint = swiper.getBreakpoint(swiper.params.breakpoints);
        let slidesPerView = breakpoint ? swiper.params.breakpoints[breakpoint].slidesPerView : swiper.params.slidesPerView;
        let totalSlides = swiper.el.querySelectorAll('.carousel__slide').length;
        if (swiper.params.loop && totalSlides <= slidesPerView) {
          swiper.params.loop = false;
          swiper.originalParams.loop = false;
        }
      },
      init: function (swiper) {
        // Bind infinite-slider-layout__prev and __next buttons
        let $layout = swiper.$el.closest('.infinite-slider-layout');

        if ($layout.length) {
          // Buttons are direct children of the layout, not nested inside .find()
          let $prevBtn = $layout.children('.infinite-slider-layout__prev');
          let $nextBtn = $layout.children('.infinite-slider-layout__next');

          // Remove any existing handlers for THIS layout only
          $prevBtn.off('click');
          $nextBtn.off('click');

          // Bind new handlers that reference this specific swiper instance
          $prevBtn.on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (swiper && swiper.slidePrev) {
              swiper.slidePrev();
            }
          });

          $nextBtn.on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (swiper && swiper.slideNext) {
              swiper.slideNext();
            }
          });

          // Pause autoplay on hover over slides
          if (swiper.autoplay && swiper.autoplay.running) {
            $(swiper.$el).find('.swiper-slide').on('mouseenter', function() {
              if (swiper.autoplay) {
                swiper.autoplay.stop();
              }
            });

            $(swiper.$el).find('.swiper-slide').on('mouseleave', function() {
              if (swiper.autoplay) {
                swiper.autoplay.start();
              }
            });
          }

          let $firstImage = $(swiper.$el).find('.card-infinite__image').first();
          if ($firstImage.length) {
            let pictureHeight = $firstImage.height();
            if (pictureHeight) {
              $layout.css('--image-height', pictureHeight+'px');
            }
          }
        }

        updateSwiperHeight(swiper);
      },
      slideChangeTransitionEnd: function(swiper) {
        updateSwiperHeight(swiper);
      },
      resize: function(swiper) {
        updateSwiperHeight(swiper);
      }
    },
  }
}

// Check for infinite sliders that never initialized (not enough slides)
function checkInfiniteSliders() {
  $('.infinite-slider-layout').each(function() {
    let $layout = $(this);
    let $carousel = $layout.find('.carousel');

    // If there's no carousel element, or the carousel doesn't have swiper initialized
    if ($carousel.length === 0 || !$carousel[0].swiper) {
      $layout.addClass('slider-disabled');
    } else {
      // Carousel exists and has swiper - check if it's locked
      let swiper = $carousel[0].swiper;
      if (swiper.isLocked) {
        $layout.addClass('slider-disabled');
      } else {
        // Check if there are actually enough slides
        let totalSlides = swiper.slides ? swiper.slides.length : 0;
        let slidesPerView = swiper.params.slidesPerView === 'auto' ? 1 : swiper.params.slidesPerView;

        if (totalSlides <= slidesPerView) {
          $layout.addClass('slider-disabled');
        } else {
          $layout.removeClass('slider-disabled');
        }
      }
    }
  });
}

$(document).ready(function() {
  checkInfiniteSliders();
});

// Recheck on window resize
$(window).on('resize', function() {
  checkInfiniteSliders();
});

/* End: PERFORMANCE */
